import { Layout } from 'antd';
import { BreadcrumbView } from '@/components/Breadcrumb';
import { HeaderRightContent } from './HeaderRightContent';
import styles from './index.module.scss';

const { Header: AntHeader } = Layout;
export const Header = () => {
  return (
    <AntHeader className={styles.header}>
      <BreadcrumbView />
      <HeaderRightContent />
    </AntHeader>
  );
};
